const contacts: { href: string; ext: boolean }[] = [
  // { href: 'https://www.facebook.com/angelzbg', ext: true },
  { href: 'https://www.linkedin.com/in/angel-zlatanov-9379ba1ba/', ext: true },
  { href: 'https://github.com/angelzbg', ext: true },
  { href: 'https://stackoverflow.com/users/14342112/angel-zlatanov?tab=profile', ext: true },
  { href: 'mailto:angel.zlatanovv@gmail.com', ext: false },
];

export { contacts };
